export default function Footer({ children }) {
  return <footer className="footer">{children}</footer>;
}
